import StandaloneStorageManager from "./storage/StandaloneStorageManager";
import StandaloneIndexedDB from "./storage/StandaloneIndexedDB";

export const isStandalone = () => process.env.REACT_APP_IS_STANDALONE === 'true';

export const standaloneStorageManager = new StandaloneStorageManager(new StandaloneIndexedDB());
